import { render, staticRenderFns } from "./Suscripcion.vue?vue&type=template&id=8f1a4398"
import script from "./Suscripcion.vue?vue&type=script&lang=js"
export * from "./Suscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports